import { TabList } from "@mui/lab";
import { styled } from "@mui/material";
import { TimeField } from "@mui/x-date-pickers";
import { ToastContainer } from "react-toastify";

export const NotificationRelative = styled("div")(() => ({
  position: "fixed",
  bottom: "2rem",
  padding: "3px",
  zIndex: 99,
  right: "2.2rem",
  borderRadius: "50%",
  background: "#fff",
  boxShadow: "1px 1px 5px 0px rgba(16, 24, 40, 0.43)",
  "& svg": {
    width: "25px",
    height: "25px",
    fill: "#7F56D9",
  },
}));

export const ArrowMenu = styled("div")(() => ({
  // "& .MuiPaper-root": {
  position: "relative",
  width: "max-content",
  right: "1.5rem",
  margin: "0px 0px 0px auto",
  bottom: "6rem",
  borderRadius: "10px",
  boxShadow: "1px 1px 5px 0px rgba(16, 24, 40, 0.43)",
  overflow: "visible",
  padding: "10px",
  gap: "10px",
  background: "#fff",
  zIndex: 999,
  "&::before": {
    content: '""',
    position: "absolute",
    bottom: "-8px",
    right: "8%",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: "8px solid #fff",
    filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))",
  },
  // },
}));

export const StyleToastContainer = styled(ToastContainer)(() => ({
  "& .Toastify__toast": {
    padding: "25px 10px 0px",
    justifyContent: "center",
  },
  "& .Toastify__close-button.Toastify__close-button--light": {
    border: "1px solid #7F56D9",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    opacity: 1,
  },
  "& button svg": {
    fill: "#7F56D9",
    height: "14px",
    marginLeft: "2px",
  },
}));

export const SubscriptionTabList = styled(TabList)(() => ({
  "& .MuiTab-root": {
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#344054",
    "&:hover": {
      color: "#6941C6",
      fontWeight: "bold",
      borderBottom: "4px solid #7F56D9",
    },
  },
  "& .Mui-disabled": {
    color: "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiButtonBase-root": {
    fontSize: "16px",
    maxWidth: "none",
    display: "flex",
    alignItems: "center",
    padding: "12px 2rem",
  },
  "& .MuiTabs-flexContainer": {
    justifyContent: "space-between",
    width: "fit-content",
    gap: "1rem",
    "& .Mui-selected": {
      color: "#6941C6",
      fontWeight: "bold",
      borderBottom: "4px solid #7F56D9",
    },
  },
  "& .MuiTabs-indicator": {
    top: 0,
    height: 0,
  },
}));

export const StageTimeSetting = styled(TimeField)(({ values }) => ({
  "& .MuiInputBase-root": {
    padding: "0px 5px 0px 0px",
  },
  "& .MuiFormLabel-root": {
    top: values ? "0px" : "-7px",
  },
  "& .MuiInputLabel-shrink": {
    top: "0px",
  },
  "& fieldset": {
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
  },
  "& input": {
    padding: "10px",
  },
  "& svg": {
    width: "15px",
  },
}));
